module.exports = __webpack_public_path__ + "static/media/img-4.825d4e1c.jpg";